import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";

// PDF del inventario actual del proyecto, con el mismo filtro de la pantalla
// (categoría y búsqueda). Lo genera REPORT_API con el membrete de la lista de
// personal.
export const downloadProjectInventoryPdf = async (
  projectId: number,
  fileName: string,
  category?: string,
  filter?: string
) => {
  const response = await privateFetch.get(
    URL.REQUEST_PROJECT_INVENTORY_PDF(projectId, category, filter),
    { responseType: "blob" }
  );
  const blob = new Blob([response.data], { type: "application/pdf" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(link.href);
};
